module.exports = "<list-view\n  title=\"Payment Methods\"\n  item-state=\"paymentmethod\"\n  transformer=\"PaymentMethodsTransforms\"\n  resource=\"PaymentMethod\"\n  resource-params=\"$ctrl.resourceParams\"\n  add-item-event=\"$ctrl.addItemEvent\"\n  add-item-customize-options=\"$ctrl.addItemCustomizeOptions\"\n  paginate-event=\"$ctrl.paginateEvent\"\n  no-items-text=\"No Available Payment Method\"\n></list-view>\n\n<main-footer></main-footer>\n<main-sidenav sections=\"$ctrl.sections\"></main-sidenav>\n";


//////////////////
// WEBPACK FOOTER
// ./src/pages/paymentMethods/paymentMethods.html
// module id = 2190
// module chunks = 0